import { injectable } from 'inversify';
import Long from 'long'
import { Message, Field, Type } from "protobufjs/light";
import { Result, ok } from '@xlearn/common'
import * as Api from '@/app/state-serialization/api'
import { BadgeState, BadgeStatus } from '../common'
import { ProtobufSerializer } from '@/app/state-serialization/infrastructure';

@injectable()
export class BadgeStateProtobufSerializer implements Api.StateSerializationPlugin<BadgeState[]> {

  key = { id: 3, name: { ns: 'suspend-data', name: 'badges' }, format: 'protobuf' }

  serialize(data: BadgeState[]): Result<Uint8Array, Api.SerializerError> {

    const badges = data.map(badge => {

      let common = {
        id: badge.id,
        status: mapStatus(badge.status)
      }
      
      switch (badge.status) {
        case 'earned':
          return new BadgeStateProtoMessage({
            ...common,
            date: ProtobufSerializer.serializeDate(badge.date)
          })
        default:
          return new BadgeStateProtoMessage(common)
      }
    })

    const message = new BadgeStatesProtoMessage({
      badges: badges
    })

    return ProtobufSerializer.serialize<BadgeStatesProtoMessage>(message, BadgeStatesProtoMessage)
    
    function mapStatus(input: BadgeStatus) {
      switch (input) {
        case 'unknown':
          return BadgeStatusProtoEnum.unknown
        case 'not-earned':
          return BadgeStatusProtoEnum.notEarned
        case 'earned':
          return BadgeStatusProtoEnum.earned
      }
    }
  }

  deserialize(content: Uint8Array): Result<BadgeState[], Api.DeserializerError> {

    const deserializeResult = ProtobufSerializer.deserialize<BadgeStatesProtoMessage>(content,
                                                                                      BadgeStatesProtoMessage)
    if (!deserializeResult.success) {
      return deserializeResult
    }

    const badges = deserializeResult.value.badges.map(badge => {

      let common = {
        id: badge.id,
        status: mapStatus(badge.status)
      }
      
      let state: BadgeState
      switch (common.status) {
        case 'earned':
          state = {
            id: common.id,
            status: common.status,
            date: ProtobufSerializer.deserializeDate(badge.date)
          }
          break
        default:
          state = {
            id: common.id,
            status: common.status
          }
          break
      }

      return state
    })

    return ok(badges)

    function mapStatus(input: BadgeStatusProtoEnum): BadgeStatus {
      switch (input) {
        case BadgeStatusProtoEnum.unknown:
          return 'unknown'
        case BadgeStatusProtoEnum.notEarned:
          return 'not-earned'
        case BadgeStatusProtoEnum.earned:
          return 'earned'
      }
    }
  }
}

enum BadgeStatusProtoEnum {
  unknown = 0,
  notEarned = 1,
  earned = 2
}

@Type.d('BadgeStateProtoMessage')
class BadgeStateProtoMessage extends Message<BadgeStateProtoMessage> {

  @Field.d(1, 'string', "optional", '')
  id: string
  
  @Field.d(2, BadgeStatusProtoEnum, "optional", BadgeStatusProtoEnum.unknown)
  status: BadgeStatusProtoEnum;

  @Field.d(3, 'uint64', "optional", 0)
  date: Long;
}

@Type.d('BadgeStatesProtoMessage')
class BadgeStatesProtoMessage extends Message<BadgeStatesProtoMessage> {

  @Field.d(1, 'uint32', 'optional', 1)
  public schemaVersion: number

  @Field.d(2, BadgeStateProtoMessage, 'repeated')
  public badges: BadgeStateProtoMessage[]
}
